import React from 'react';

const OpportunityCard = React.memo(({ opportunity, potentialColor }) => (
  <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
    <div className="flex items-start space-x-3">
      <span className="text-xl">🚀</span>
      <div className="flex-1">
        <div className="flex items-center justify-between mb-2">
          <h4 className="font-semibold text-gray-900">{opportunity.title}</h4>
          <span className={`text-sm font-medium ${potentialColor(opportunity.potential)}`}>
            {opportunity.potential.toUpperCase()} POTENTIAL
          </span>
        </div>
        <p className="text-sm text-gray-700 mb-2">{opportunity.description}</p>
        <div className="flex items-center space-x-4 mb-2 text-sm">
          <span>Your Level: {opportunity.currentLevel}/5</span>
          <span>Market Demand: {opportunity.marketDemand}%</span>
        </div>
        <p className="text-sm font-medium text-blue-700 mb-2">{opportunity.recommendation}</p>
        <div className="bg-blue-100 px-3 py-2 rounded text-sm font-medium text-blue-800">
          Potential Impact: {opportunity.potentialIncrease}
        </div>
      </div>
    </div>
  </div>
));

export default OpportunityCard;
